class OrderIdentifier extends HTMLElement {
 constructor() {
  super();
  this.input = this.querySelector(`#order-identifier`);
  this.input.addEventListener('change',this.addOrderIdentifier.bind(this));
 }
 async addOrderIdentifier(){
  const identifier = this.input.value

   await fetch("/cart/update.js", {
     method: "POST",
     headers: { "Content-Type": "application/json" },
     body: JSON.stringify({ attributes: { "_order-identifier": identifier } })
   });
 }
}

customElements.define(`order-identifier`,OrderIdentifier);